import { Component, EventEmitter, Input, Output } from '@angular/core'
import { MbConstants } from '../../mb-constants'
import { Address, BaseSiteService } from '@spartacus/core'
import { map } from 'rxjs/operators'
import { MbCheckoutRegions } from '../../../models'

@Component({
  selector: 'mb-address-tile',
  templateUrl: './mb-address-tile.component.html',
  styleUrls: ['./mb-address-tile.component.scss'],
})
export class MbAddressTileComponent {

  constants = MbConstants
  checkoutRegions = MbCheckoutRegions
  supportingAccountCreation$ = this.baseSiteService.get().pipe(
    map(activeBaseSite => !!activeBaseSite?.supportingAccountCreation)
  )
  supportingGuestCheckout$ = this.baseSiteService.get().pipe(
    map(activeBaseSite => !!activeBaseSite?.supportingGuestCheckout)
  )

  @Input() showSelectionRadiobox = true

  @Input() address: Address | undefined

  @Input() isSelectedAddress = false

  @Input() formRegion = this.checkoutRegions.EU

  @Output() addressSelected = new EventEmitter<any>()

  constructor (protected baseSiteService: BaseSiteService) {}

  onAddressSelected (event: Event) {
    event.preventDefault()
    if (
      this.address?.verificationStatus !==
      this.constants.ADDRESS_VERIFIED_REJECTED_STATUS_04
    ) {
      this.addressSelected.emit(this.address)
    }
  }

  get hasSalesTaxExemption () {
    return !!this.address?.billingAddress && this.formRegion === this.checkoutRegions.US &&
      this.address?.hasOwnProperty(this.constants.SALES_TAX_EXEMPT_CODE)
  }
}
